import styled from 'styled-components';

export type BadgeVariant = 'success' | 'error' | 'warning' | 'neutral';
export type BadgeSize = 'sm' | 'md';

export interface BadgeProps {
  $variant: BadgeVariant;
  $size?: BadgeSize;
}

export const Badge = styled.span<BadgeProps>`
  display: inline-block;
  padding: ${({ $size = 'sm' }) =>
    $size === 'sm' ? '0.25rem 0.5rem' : '0.375rem 0.75rem'};
  border-radius: 4px;
  font-size: ${({ $size = 'sm' }) => ($size === 'sm' ? '0.75rem' : '0.875rem')};
  font-weight: 600;
  text-transform: uppercase;
  color: var(--white);
  background: ${({ $variant }) => {
    switch ($variant) {
      case 'success':
        return 'var(--success)';
      case 'error':
        return 'var(--error)';
      case 'warning':
        return 'var(--orange)';
      case 'neutral':
        return 'var(--grey-400)';
    }
  }};
`;
